<template>
  <div class="slider">
    <v-carousel
        cycle
        height="320"
        hide-delimiter-background
        show-arrows-on-hover
        class="dnMob"
    >
        <v-carousel-item
            v-for="(url, i) in img"
            :key="i"
        >
        <v-sheet
            height="100%"
        >
            <v-row
              class="fill-height"
              align="center"
              justify="center"
            >
              <div class="display-3">
                <img
                  v-if="url"
                  :src="'https://ecodom04.com/backend/'+url"
                  alt="slider"
                >
                <img
                    v-if="!url"
                    src="../assets/not_found.png"
                    alt="slider"
                >
              </div>
            </v-row>
        </v-sheet>
        </v-carousel-item>
    </v-carousel>
    <v-carousel
        cycle
        height="170"
        hide-delimiter-background
        show-arrows-on-hover
        class="dnPc"
    >
        <v-carousel-item
            v-for="(url, i) in img"
            :key="i"
        >
        <v-sheet
            height="100%"
        >
            <v-row
              class="fill-height"
              align="center"
              justify="center"
            >
              <div class="display-3">
                <img
                    v-if="url"
                    :src="'https://ecodom04.com/backend/'+url"
                    alt="slider"
                >
                <img
                    v-if="!url"
                    src="../assets/not_found.png"
                    alt="slider"
                >
              </div>
            </v-row>
        </v-sheet>
        </v-carousel-item>
    </v-carousel>
  </div>
</template>

<script>
export default {
  name: 'SlideProduct',
  components: {
  },
  props: ['img'],
}
</script>
<style scoped lang="less">
@baseMedia: 900px;
.dnPc {
   display: none;
   @media (max-width: @baseMedia) {
      display: block;
   }
}
.dnMob {
   display: block;
   @media (max-width: @baseMedia) {
      display: none;
   }
}
.display-3 {
    width: 100%;
    height: 100%;
    text-align: center;
    background: #fff;
    img {
        width: auto;
        max-height: 320px;
        @media (max-width: @baseMedia) {
            max-height: 170px;
        }
    }
}
.v-window__next {
    right: 0;
}
</style>